import React, { useEffect } from "react";
import { MotifSelect, MotifFormField,  MotifOption} from '@ey-xd/motif-react';

type SelectBoxType = {
    options: {label : string, value: string}[]; 
    value: string;
    onChange: Function;
    filter?: boolean | ((x?: any) => void) | undefined;
    searchPlaceholder? : string;
    defaultValue?: string;
    visibleOptions?: number;
    placeholder?: string;
    disabled?: boolean;
    multiple?: boolean;
    onChangeHandler?: (val: string) => void;
}

export default function SelectBox ({ options, value, defaultValue, onChange, filter, searchPlaceholder, visibleOptions,placeholder,disabled,multiple, onChangeHandler}: SelectBoxType) {
    useEffect(() => {
        const btn = document.querySelectorAll('.motif-select-input') as NodeListOf<Element>;
        btn.forEach((element: Element) => {
            (element as HTMLElement).setAttribute('type', 'button');
        });
    },[]);
    const selectedValue = value || defaultValue || '';
    const onChangeHandlerEvent = (val : string) => {
        onChangeHandler && onChangeHandler(val);
        onChange(val);
    }
    return (
        <> 
            <MotifFormField role="group"> 
                {/*@ts-ignore */}
                <MotifFormField>
                    <MotifSelect
                        ariaLabelledBy="select-label"
                        onChange={onChangeHandlerEvent}
                        value={selectedValue}
                        filter={filter}
                        searchPlaceholder={searchPlaceholder}
                        visibleOptions={visibleOptions}
                        placeholder={placeholder}
                        disabled={disabled === true ? true : false}
                        multiple={multiple}
                    >
                        {
                            options.map( (option,index) => (
                                <MotifOption isSelected={option.value === selectedValue} key={`${option.value}-${index}`} value={option.value}>{option.label}</MotifOption>
                            ))
                        }
                    </MotifSelect>
                </MotifFormField> 
            </MotifFormField>
        </>
        
    );
}